import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getForgotPassword,
  updateResetPassword
} from '../../api/reset-password-external-users';

export const getForgotPasswordAsync = createAsyncThunk(
  'resetPasswordExternalUsers/getForgotPassword',
  getForgotPassword
);

export const updateResetPasswordAsync = createAsyncThunk(
  'resetPasswordExternalUsers/updateResetPassword',
  updateResetPassword
);
